import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { FamilyService } from './family.service';

export const familyInterceptor: HttpInterceptorFn = (req, next) => {
  const familyService = inject(FamilyService);
  const selected = familyService.selectedFamily();
  const familyId = selected?.id;
  if (!familyId || req.url.startsWith('assets/') || req.headers.has('X-Family-Id')) {
    return next(req);
  }
  const augmented = req.clone({
    setHeaders: {
      'X-Family-Id': familyId
    }
  });
  return next(augmented);
};
